import create  from "zustand";
import shallow from "zustand/shallow";
// import classNames from "classnames";

// import styles from "./Snackbar.module.css";
import "../index.css"

// export const SNACKBAR_DURATIONS = Object.freeze({
//   "1_5_SECS": 1500,
//   "2_5_SECS": 2500,
// });

export const useSnackbar = create((set) => ({
  message: "",
  show: false,
  showMessage: (message) => {
    set({ message: message, show: true });
    setTimeout(() => set({ message: "", show: false }), 3500);
  }
}))


export function Snackbar() {
  const { show, message } = useSnackbar((state) => ({ message: state.message, show: state.show }), shallow);
  
  return (
    <div id="mdb-snackbar" className={show && "show"}>
      {message}
    </div>
  );
}
